import { useState, MouseEvent, useEffect } from "react";
import { Box, Divider, PopoverOrigin, Typography } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { ImageAssets } from "@/assets";
import { SideBarItemType } from "@/types/view";
import theme from "@/theme/material";
import { EventBusUtils, StorageUtils, SystemUtils } from "@/utils";
import { EventConstant, KeyConstant } from "@/const";
import useMenuHeader from "../hooks/useMenuHeader";
import MenuItem from "./MenuItem";
import SidebarMobileDrawer from "./SidebarMobileDrawer";
import { AppBarHeader, HeaderUser, AvatarUser, UserMenuList, AppBarContainer, LogoContainer } from "./MainHeader.style";

type MainHeaderUserType = {
  name: string;
  avatar: string;
};

const ANCHOR_POSITION: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "right",
};

const MainHeader = () => {
  const { menuList } = useMenuHeader();

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const [user, setUser] = useState<MainHeaderUserType>({
    name: "",
    avatar: "",
  });

  const handleOpenUserMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleGetUserInfo = () => {
    const name = StorageUtils.getItem<string>(KeyConstant.KEY_NAME) || "unknow";
    const avatar = StorageUtils.getItem<string>(KeyConstant.KEY_AVATAR) || "";
    setUser({ name, avatar });
  };

  useEffect(() => {
    handleGetUserInfo();
  }, []);

  useEffect(() => {
    EventBusUtils.on(EventConstant.PROFILE_EVENTS.updateProfile, handleGetUserInfo);

    return () => {
      EventBusUtils.off(EventConstant.PROFILE_EVENTS.updateProfile, handleGetUserInfo);
    };
  });

  const isExpandUserMenu = Boolean(anchorElUser);

  return (
    <AppBarHeader position="static" elevation={0} color="inherit">
      <AppBarContainer>
        <SidebarMobileDrawer />

        <LogoContainer>
          <img src={ImageAssets.LogoImage} alt="Secured Gateway" height="100%" width="100%" />
        </LogoContainer>

        <Box sx={{ flexGrow: 1 }} />

        <Box className="flex-center">
          <Divider orientation="vertical" flexItem />

          <HeaderUser onClick={handleOpenUserMenu}>
            <AvatarUser alt={user.name} src={SystemUtils.getAttachmentFromPath(user.avatar)}>
              {user.name.charAt(0)}
            </AvatarUser>
            <Typography fontWeight={theme.typography.fontWeightMedium}>{user.name}</Typography>
            {isExpandUserMenu ? <ExpandLess /> : <ExpandMore />}
          </HeaderUser>

          <UserMenuList
            id="user-menu"
            open={isExpandUserMenu}
            anchorEl={anchorElUser}
            anchorOrigin={ANCHOR_POSITION}
            keepMounted
            onClose={handleCloseUserMenu}
          >
            {menuList.map((menuItem: SideBarItemType) => (
              <MenuItem onItemClick={handleCloseUserMenu} menuItem={menuItem} key={menuItem.key} />
            ))}
          </UserMenuList>
        </Box>
      </AppBarContainer>
    </AppBarHeader>
  );
};

export default MainHeader;
